export default "__VITE_ASSET__c02d5135__"